export function downloadFile(fileUrl: string, fileName?: string) {
  const link = document.createElement('a');
  link.href = fileUrl;
  link.download = fileName || 'SparkUp-Resource-file';
  document.body.appendChild(link);
  link.target = '_blank';
  link.click();
  document.body.removeChild(link);
}

export function viewFile(fileUrl: string) {
  if (fileUrl) {
    window.open(fileUrl, '_blank');
  } else {
    console.error('URL is not valid.');
  }
}
